import {
	Discoball,
	Film,
	Instrument,
	Smiley,
	Toolkit,
} from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import type { FacetHit } from '@/utils/algolia/autocompleteHitTypes'

import searchBoxStyles from '../../../SearchBox.module.css'
import { AutocompleteItem, HighlightedText } from '../../components'

const FACET_DISPLAY_CONFIG = {
	MusicalStyles: {
		translatedName: 'musical-styles',
		icon: <Discoball size="medium" />,
	},
	Moods: {
		translatedName: 'moods',
		icon: <Smiley size="medium" />,
	},
	Instrumentations: {
		translatedName: 'instrumentations',
		icon: <Instrument size="medium" />,
	},
	ProductionGenres: {
		translatedName: 'production-genres',
		icon: <Film size="medium" />,
	},
	Toolkit: {
		translatedName: 'toolkit',
		icon: <Toolkit size="medium" />,
	},
}

export const FacetOption = ({
	item,
	activeItemId,
}: {
	item: FacetHit
	activeItemId: number
}): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { facetType, label, __autocomplete_id: index } = item

	// Extract base facet name and get config directly
	const baseFacetName = facetType.split('_')[0]
	const config = FACET_DISPLAY_CONFIG[baseFacetName]

	return (
		<button
			aria-selected={activeItemId === index}
			className={searchBoxStyles.option}
			data-value={label}
			id={`${label}-listbox-option`}
			role="option"
			type="button"
		>
			<AutocompleteItem
				icon={config.icon}
				title={<HighlightedText AlgoliaHit={item} fields="label" />}
				subtitle={t(config.translatedName)}
				data-testid="facet-suggestion"
			/>
		</button>
	)
}
